import type { ComponentType } from 'react';
import type { TemplateType } from '@/services/provisioningProfileService';
import {
  DocumentTextIcon,
  ChartBarIcon,
  PresentationChartLineIcon,
  Squares2X2Icon,
  UserGroupIcon,
  ShieldExclamationIcon,
  UserIcon,
  HeartIcon,
  ListBulletIcon,
  Cog6ToothIcon,
} from '@heroicons/react/24/outline';

export interface ProvisioningTemplateTypeItem {
  type: TemplateType;
  label: string;
  icon: ComponentType<{ className?: string }>;
  description: string;
}

/** Icon + type only; use provisioningTemplateTypeItems(t) for translated label/description. */
export const PROVISIONING_TEMPLATE_TYPE_ICONS: Array<{
  type: TemplateType;
  icon: ComponentType<{ className?: string }>;
}> = [
  { type: 'ROADMAP', icon: DocumentTextIcon },
  { type: 'TRANSFORMATION', icon: PresentationChartLineIcon },
  { type: 'KPI', icon: ChartBarIcon },
  { type: 'HIERARCHY', icon: Squares2X2Icon },
  { type: 'ROLE', icon: UserGroupIcon },
  { type: 'POSITION', icon: UserIcon },
  { type: 'PROCESS_AREAS', icon: Cog6ToothIcon },
  { type: 'RISK', icon: ShieldExclamationIcon },
  { type: 'STAKEHOLDER', icon: HeartIcon },
  { type: 'CRM_LIST', icon: ListBulletIcon },
];

/** Same order as the icon bar / modal; labels from DB via t(). */
export function provisioningTemplateTypeItems(t: (key: string) => string): ProvisioningTemplateTypeItem[] {
  return PROVISIONING_TEMPLATE_TYPE_ICONS.map(({ type, icon }) => ({
    type,
    icon,
    label: t(`provisioningProfiles.templateType.${type}.label`),
    description: t(`provisioningProfiles.templateType.${type}.description`),
  }));
}
